<template>
  <v-card class="card">
    <v-card-title class="zamg-text-headline">
      {{ title }}
    </v-card-title>
    <v-card-text class="fill-height d-flex flex-column">
      <v-text-field
        v-if="showSearch"
        v-model="search"
        class="flex-none mb-4"
        prepend-icon="mdi-magnify"
        data-testid="parameter-search"
        :label="t('search') + '...'"
        single-line
        hide-details
        variant="outlined"
        density="compact"
        clearable
      />
      <div class="scrollable-container">
        <v-data-table
          v-model="localSelected"
          class="mt-4 param-table"
          item-key="name"
          items-per-page="-1"
          hide-default-footer
          :items="items"
          :headers="headers"
          :search="search"
          :return-object="true"
          :loading-text="t('loading')"
          :no-data-text="t('no_data_available')"
          checkbox-color="primary"
          :show-select="showSelect"
          @update:model-value="emitSelected"
        />
      </div>
    </v-card-text>
  </v-card>
</template>

<script lang="ts">
import { defineComponent, ref, computed } from 'vue';
import type { DataTableHeader } from 'vuetify';
import type { Parameter } from '@/stores/parameter/parameter-model';
import { useI18n } from "vue-i18n";

export default defineComponent({
  name: 'ParameterCard',
  props: {
    title: { type: String, required: true },
    showSearch: { type: Boolean, default: true },
    showSelect: { type: Boolean, default: true },
    items: { type: Array as () => Parameter[], required: true },
    selected: { type: Array as () => Parameter[], required: true },
  },
  emits: ['selectedChanged'],
  setup(props, { emit }) {
    const { t } = useI18n();

    const search = ref('');
    const localSelected = ref([...props.selected])

    function emitSelected(parameters: Parameter[]): void {
      emit('selectedChanged', parameters);
    }

    const headers = computed<DataTableHeader[]>(() => {
      const defaultProps: Partial<DataTableHeader> = {
        headerProps: {'class': 'zamg-text-continuous zamg-text-input'},
        align: 'start',
        sortable: false,
      }
      return [
        {
          ...defaultProps,
          title: t('parameter.name').toString(),
          key: 'name',
        },
        {
          ...defaultProps,
          title: t('parameter.shortDesc').toString(),
          key: 'shortDesc',
        },
        {
          ...defaultProps,
          title: t('parameter.unit').toString(),
          key: 'unit',
        },
      ];
    });

    return {
      t,
      search,
      headers,
      emitSelected,
      localSelected,
    };
  },
});
</script>

<style scoped>
.card {
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  width: 100%;
  min-height: 0;
}

.v-card-text {
  display: flex;
  flex-direction: column;
  flex: 1 1 0;
  min-height: 0;
}

.scrollable-container {
  flex: 1 1 0;
  min-height: 0;
  overflow-y: auto;
}

.param-table {
  width: 100%;
}
</style>
